/*
==========================================
Custom main-cart.liquid
==========================================
*/

// Novelty追加処理
const addNovelty = (e) =>{
  e.preventDefault();
  const variant_id = e.target.dataset.variant_id;
  let formData = {
    items: [{
     id: Number(variant_id),
     quantity: 1
     }]
   };

  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data && typeof data.items === 'undefined') {
        alert("特典商品の在庫がありません。");
        window.location.reload();
      }else{
        window.location.href = "/cart"
      }
    })
    .catch((error) => {
      alert("エラーが発生しました。ページを再表示します。");
      console.error('Error:', error);
      window.location.reload()
    });
}